export const User = {
  state: {
    user: {},
    users: []
  },
  mutations: {
    /* Current User */
    setUser (state, payload) {
      state.user = payload
    },
    updateUserProperties (state, payload) {
      state.user = _.assign(state.user, payload.user)
    },
    /* User List */
    setUsers (state, payload) {
      state.users = payload.users
    },
    addUserToUsers (state, payload) {
      state.users.push(payload.user)
    },
    removeUserFromUsers (state, payload) {
      state.users = _.filter(state.users, (user) => {
        return user.id !== payload.userId
      })
    }
  },
  actions: {
    updateUser ({ commit, dispatch }, payload) {
      if (payload.taskSortType) dispatch('updateSortTaskBy', payload.taskSortType)
      if (payload.role === 'designer' && payload.dailyAvailability === undefined) {
        payload.dailyAvailability = 8 // TODO temp solution to add new property dailyAvailability
      }
      commit('setUser', payload)

    }
  },
  getters: {
    getUser: state => state.user,
    getUsers: state => state.users
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/User.js